<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Dodawanie pracownika</h4>
			  	<Link :href="route('kadry.lista')" class="btn btn-outline-primary">
				  <i class="bi bi-list"></i>&nbsp;Powrót do listy
				</Link>
            </div>
          </div>
        </div>
        <div class="widget-content">
		
		  <div class="col-md-6 mb-4">
		    <div class="card h-100 shadow-sm">
		      <div class="card-body d-flex flex-column justify-content-start">
				<div class="row">
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="first_name">* Imię:</label>
					<input id="first_name" v-model="newUser.first_name" class="form-control" required/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="last_name">* Nazwisko:</label>
					<input id="last_name" v-model="newUser.last_name" class="form-control" required/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
				    <label class="form-label" for="kod_pocztowy">Kod pocztowy:</label>
				    <input id="kod_pocztowy" v-model="newUser.kod_pocztowy" class="form-control"/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="miasto">Miasto:</label>
					<input id="miasto" v-model="newUser.miasto" class="form-control"/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="ulica">Ulica:</label>
					<input id="ulica" v-model="newUser.ulica" class="form-control"/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="nr_domu">Numer domu/mieszkania:</label>
					<input id="nr_domu" v-model="newUser.nr_domu" class="form-control"/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="nr_telefonu">Telefon:</label>
					<input id="nr_telefonu" v-model="newUser.nr_telefonu" class="form-control"/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="phone">Telefon firmowy:</label>
					<input id="phone" v-model="newUser.phone" class="form-control"/>
				  </div>	
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="email">E-mail:</label>
					<input id="email" v-model="newUser.email" class="form-control"/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<label class="form-label" for="email_f">* E-mail firmowy:</label>
					<input id="email_f" v-model="newUser.email_f" class="form-control" required/>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<div class="checkbox-success custom-control custom-checkbox mb-2 mt-2">
					  <input id="saveSmart" type="checkbox" class="custom-control-input" v-model="saveSmart" @change="checkSmart">
					  <label for="saveSmart" class="custom-control-label h6 mt-1">Utwórz konto w SMART</label>
					</div>
				  </div>
				  <div class="col-md-6 col-lg-6 mb-3">
					<button @click="saveNewUser" class="btn btn-success mt-2">Dodaj pracownika</button>
				  </div>		  
				</div>
			  </div>
			</div>
		  </div>

        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import { usePermission } from "@/composables/resources/js/composables/permissions.js";

const { hasPermission } = usePermission();

export default {
  components: { AppLayout },
  props: {
    departamenty: Array,
    typy_umow: Array,
    typy_etaty: Array
  },
data() {
  return {
    hasPermission,
    newUser: {
      first_name: '',
      last_name: '',
      kod_pocztowy: '',
      miasto: '',
      ulica: '',
      nr_domu: '',
      nr_telefonu: '',
      phone: '',
      email: '',
      email_f: '',
	  
    },
	saveSmart: false
  };
},
  methods: {
checkSmart() {
    console.log('saveSmart: ', this.saveSmart);
},

saveNewUser() {

  if (!this.newUser.first_name) {
    Toast.fire({
      icon: 'error',
      title: 'Błąd!',
      text: 'Podaj imię pracownika.',
    });
    return;
  }
  if (!this.newUser.last_name) {
    Toast.fire({
      icon: 'error',
      title: 'Błąd!',
      text: 'Podaj nazwisko pracownika.',
    });
    return;
  }
   if (!this.newUser.email_f && !this.newUser.email) {
    Toast.fire({
      icon: 'error',
      title: 'Błąd!',
      text: 'Adres e-mail jest wymagany!',
    });
    return;
  }
  
     if (!this.newUser.email_f && this.newUser.email) {
		this.newUser.email_f = this.newUser.email;
	}
	
  // sprawdzanie czy dodać do smart
  if (!this.saveSmart) {
    Toast.fire({
      toast: false,
      icon: 'warning',
      title: 'Dodawanie konta pracownika',
      html: 'Czy na pewno chcesz dodać konto pracownika bez utworzenia konta w SMART?',
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: 'Tak',
      denyButtonText: 'Nie',
      timer: false,
      position: 'center'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('saveSmart: ', this.saveSmart);
        console.log('newUser: ', this.newUser);
		
this.$inertia.post(route('kadry.user.add'), {
    ...this.newUser,
    saveSmart: this.saveSmart
}, {
    onSuccess: () => {

        this.newUser = {};
        Toast.fire({
            icon: 'success',
            title: 'Poprawnie utworzono nowego pracownika'
        });
    },
    onError: (errors) => {
        if (errors.message) {
            Toast.fire({
                icon: 'error',
                title: 'Błąd!',
                text: errors.message
            });
        }
    }
});
      }
    });
  } else {
		console.log('saveSmart: ', this.saveSmart);
		console.log('newUser: ', this.newUser);
			
this.$inertia.post(route('kadry.user.add'), {
    ...this.newUser,
    saveSmart: this.saveSmart
}, {
    onSuccess: () => {
        this.saveSmart = false;
        this.newUser = {};
        Toast.fire({
            icon: 'success',
            title: 'Poprawnie utworzono nowego pracownika'
        });
    },
    onError: (errors) => {
        if (errors.message) {
            Toast.fire({
                icon: 'error',
                title: 'Błąd!',
                text: errors.message
            });
        }
    }
});
	  
  }
}

  }
};
</script>
